import React from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { LOGIN_PAGE_EXTENSION } from "./helpers/constants/Constants";
import Login from "./pages/Login";
import IfLoggedIn from "./components/auth/IfLoggedIn";
import { LicenseManager } from "ag-grid-enterprise";

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import {
  SetFilterModule,
  RowGroupingModule,
  CellSelectionModule,
  RichSelectModule,
  ContextMenuModule,
  ExcelExportModule,
  ColumnMenuModule,
} from "ag-grid-enterprise";

ModuleRegistry.registerModules([
  AllCommunityModule,
  SetFilterModule,
  RowGroupingModule,
  CellSelectionModule,
  RichSelectModule,
  ContextMenuModule,
  ExcelExportModule,
  ColumnMenuModule,
]);

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-092604}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{MWH_Treatment}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Mview}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Mview}_need_to_be_licensed___{Mview}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{25_November_2026}____[v3]_[01]_MTc5NTU2NDgwMDAwMA==297f40973cf9c9be87cc561897ed1949"
);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={LOGIN_PAGE_EXTENSION} element={<Login />} />
        <Route path="/no-access" element={<Login accessDenied />} />
        <Route path="*" element={<IfLoggedIn />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
